import { call, put, select } from "redux-saga/effects";
import cirrusClient from "../../../services/api/cirrus-client";
import { setUserCallReportLoading, setUserCallReport } from "../../../state/callCenter/userCallReportSlice";
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";

export function* fetchUserCallReportSaga(action) {
    const { timeframe } = action.payload;

    try {
        yield put(setUserCallReportLoading({ timeframe }));
        const { user, domain } = yield select(selectUserCredentials)

        const getParams = () => {
            if (timeframe === 'hourly') {
                return {
                    option: 'summaryByHour',
                    duration: '12 HOUR',
                };
            } else {
                return {
                    option: 'summaryByDay',
                    duration: '7 Day',

                };
            }
        };
        const apiUrl = `?object=cdr&action=read&format=json`;
        const params = {
            ...getParams(),
            user: user,
            domain: domain,
        };
        const response = yield call(cirrusClient.get, apiUrl, { params });
        yield put(setUserCallReport({
            timeframe,
            data: response.data
        }));

    } catch (error) {

        console.error(`Error fetching user ${timeframe} call data:`, error);
    }

}